// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PatientSharedEmailAddressUpsearchModel {
    static getAttributeTypeMap() {
        return PatientSharedEmailAddressUpsearchModel.attributeTypeMap;
    }
}
PatientSharedEmailAddressUpsearchModel.discriminator = undefined;
PatientSharedEmailAddressUpsearchModel.additionalProperties = false;
PatientSharedEmailAddressUpsearchModel.attributeTypeMap = [
    {
        "name": "emailAddressId",
        "baseName": "emailAddressId",
        "type": "number"
    },
    {
        "name": "emailAddressType",
        "baseName": "emailAddressType",
        "type": "ContactInfoPurposeType"
    },
    {
        "name": "address",
        "baseName": "address",
        "type": "string"
    },
    {
        "name": "language",
        "baseName": "language",
        "type": "string"
    },
];
//# sourceMappingURL=patientSharedEmailAddressUpsearchModel.js.map